export default __webpack_public_path__ + "static/media/squares300.bf6e038e.jpg";